export enum RatingAggregation {
  Average = "Average",
  Sum = "Sum",
}

export const ratingAggregations = [
  { label: "Durchschnitt", value: RatingAggregation.Average },
  { label: "Summe", value: RatingAggregation.Sum },
];
